import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import userbase from 'userbase-js'
import { Button } from '../components/buttons'

export const Login = ({ ready, setUser }) => {
  const history = useHistory()

  const [loginForm, setLoginForm] = useState({ username: '', password: '' })

  if (!ready) {
    return null
  }

  const handleLoginInputChange = (event) =>
    setLoginForm({ ...loginForm, [event.target.name]: event.target.value })

  const handleLoginSubmit = (event) => {
    event.preventDefault()
    if (loginForm.username && loginForm.password)
      userbase
        .signIn({
          username: loginForm.username,
          password: loginForm.password,
          rememberMe: 'local',
        })
        .then((ur) => {
          setUser(ur)
          history.replace({ pathname: '/' })
        })
        .catch((err) => alert(err))
  }

  return (
    <div className="container-md py-64">
      <h2 className="text-30 text-purple-dark text-center mb-32">Log In</h2>
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-32 py-32">
        <form onSubmit={handleLoginSubmit} id="login">
          <label className="block mb-12" htmlFor="username">
            Username *
          </label>
          <input
            className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
            id="username"
            type="text"
            name="username"
            value={loginForm.username}
            onChange={handleLoginInputChange}
            required
          />
          <label className="block mb-12" htmlFor="password">
            Password *
          </label>
          <input
            className="w-full px-16 bg-gray-100 border-1 border-gray-200 rounded-8 h-56 mb-40"
            id="password"
            type="password"
            name="password"
            value={loginForm.password}
            onChange={handleLoginInputChange}
            required
          />
        </form>
        <Button
          className="w-full bg-purple-light text-white rounded-10"
          type="submit"
          form="login"
          value="Submit"
        >
          Submit
        </Button>
      </div>
    </div>
  )
}
